export const SAVED_ITINERARY_TYPE = {
  FAVORITE: 'favorite',
  SYSTEM_RECOMMENDED: 'systemRecommended',
  AGENCY_RECOMMENDED: 'agencyRecommended',
};

const SAVED_TYPE_LABELS = {
  [SAVED_ITINERARY_TYPE.FAVORITE]: 'Favorites',
  [SAVED_ITINERARY_TYPE.SYSTEM_RECOMMENDED]: 'System Recommended',
  [SAVED_ITINERARY_TYPE.AGENCY_RECOMMENDED]: 'Agency Recommended',
};

export const savedItineraryTypeLabel = type => SAVED_TYPE_LABELS[type] || type;

export const SAVED_ITINERARY_TAG = {
  FIRST_TIME_SAFARI: 'firstTimeSafari',
  FAMILY: 'family',
  HONEYMOON: 'honeymoon',
  REPEAT_SAFARI: 'repeatSafari',
  GREAT_MIGRATION: 'greatMigration',
  DESERT_DUNES: 'desertDunes',
  BEACH: 'beach',
  RHINOS: 'rhinos',
  GORILLAS: 'gorillas',
  BIG_FIVE: 'bigFive',
  DIVING: 'diving',
  ADVENTURE_SEEKERS: 'adventureSeekers',
  PHOTOGRAPHERS: 'photographers',
  WINE: 'wine',
  HOT_AIR_BALLOON: 'hotAirBalloon',
  BIRDING: 'birding',
};

export const SAVED_ITINERARY_TAG_OPTIONS = [
  { label: 'Adventure Seekers', value: SAVED_ITINERARY_TAG.ADVENTURE_SEEKERS },
  { label: 'Beach', value: SAVED_ITINERARY_TAG.BEACH },
  { label: 'Birding', value: SAVED_ITINERARY_TAG.BIRDING },
  { label: 'Big Five', value: SAVED_ITINERARY_TAG.BIG_FIVE },
  { label: 'Desert Dunes', value: SAVED_ITINERARY_TAG.DESERT_DUNES },
  { label: 'Diving', value: SAVED_ITINERARY_TAG.DIVING },
  { label: 'Family', value: SAVED_ITINERARY_TAG.FAMILY },
  { label: 'First-time Safari', value: SAVED_ITINERARY_TAG.FIRST_TIME_SAFARI },
  { label: 'Gorillas', value: SAVED_ITINERARY_TAG.GORILLAS },
  { label: 'Great Migration', value: SAVED_ITINERARY_TAG.GREAT_MIGRATION },
  { label: 'Honeymoon', value: SAVED_ITINERARY_TAG.HONEYMOON },
  { label: 'Photographers', value: SAVED_ITINERARY_TAG.PHOTOGRAPHERS },
  { label: 'Repeat Safari', value: SAVED_ITINERARY_TAG.REPEAT_SAFARI },
  { label: 'Rhinos', value: SAVED_ITINERARY_TAG.RHINOS },
  { label: 'Hot Air Balloon', value: SAVED_ITINERARY_TAG.HOT_AIR_BALLOON },
  { label: 'Wine', value: SAVED_ITINERARY_TAG.WINE },
];

export const SAVED_ITINERARY_TAG_VALUES = Object.values(SAVED_ITINERARY_TAG);

export const SAVED_ITINERARY_DURATION_VALUES = ['short', 'medium', 'longer', 'extended'];

export const SAVED_ITINERARY_TAG_LABELS = SAVED_ITINERARY_TAG_OPTIONS.map(opt => opt.label);

const labelByValue = SAVED_ITINERARY_TAG_OPTIONS.reduce((map, opt) => {
  map[opt.value] = opt.label;
  return map;
}, {});

export const savedItineraryTagLabel = key => labelByValue[key] || key;
